import React, { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import { getTutorialDaysString, getWorkshopDaysString } from "../../util/ijcaihelpers";
const ItemCheck = ({
  condition,
  text,
}: {
  condition: boolean;
  text: string;
}) => {
  return condition ? (
    <li className="flex items-center gap-2 text-sm">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-4 w-4 text-green-600"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>

      {text}
    </li>
  ) : (
    <></>
  );
};

export const RegistrationDetails = () => {
  const { data, registrationType, optionAccess } =
    useContext(RegistrationContext);

  var registrationTypeString = "Full Delegate"; // "Full Delegate" | "Student" | "Student with Paper" | "Industry Day"
  var accessString = "Full Conference"; // "Full Conference" | "Workshops and Tutorials"
  var showTutorials = true;
  if (optionAccess === "workshops") {
    accessString = "Workshops/Tutorials/DC";
  }
  if (registrationType === "student") registrationTypeString = "Student";
  if (registrationType === "student-paper") {
    registrationTypeString = "Student with Paper";
    accessString = "Full Conference";
  }

  if (registrationType === "industry") {
    registrationTypeString = "Industry Day";
    accessString = "Industry Day";
    showTutorials = false; // Industry Day does not include workshops or tutorials
  }

  if (registrationType === "exhibitor") {
    registrationTypeString = "Exhibitor";
    accessString = "Exhibitor";
    showTutorials = false; // Exhibitor does not include workshops or tutorials
  }

  
  

  return (
    <div className="rounded-lg border bg-white p-6 shadow-sm" id="details">
      {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
      <h2 className="mb-4 text-xl font-bold">Registration Details</h2>

      <div className="grid gap-6 md:grid-cols-2">
        <div>
          <h3 className="mb-2 text-sm font-medium text-gray-500">
            Registration Information
          </h3>
          <div className="rounded-lg border p-4">
            <dl className="space-y-4">
               <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">
                  Delegate Name
                </dt>
                <dd className="text-sm font-medium">
                  {data.delegate_name}
                </dd>
              </div>
              <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">
                  Registration Code
                </dt>
                <dd className="text-sm font-medium">
                  {data.registration_code}
                </dd>
              </div>
              <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">
                  Registration Type
                </dt>
                <dd className="text-sm font-medium">
                  {registrationTypeString}
                </dd>
              </div>
              <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">Access</dt>
                <dd className="text-sm font-medium">{accessString}</dd>
              </div>
              {data.workshop_day1 ||
                data.workshop_day2 ||
                data.workshop_day3 ? (
                <div className="flex justify-between">
                  <dt className="text-sm font-medium text-gray-500">
                    Workshop days registered
                  </dt>
                  <dd className="text-sm font-medium">
                    {getWorkshopDaysString(data)}
                  </dd>
                </div>
              ) : (
                <> </>
              )}
              {showTutorials && (data.tutorial_day1 ||
                data.tutorial_day2 ||
                data.tutorial_day3) ? (
                <div className="flex justify-between">
                  <dt className="text-sm font-medium text-gray-500">
                    Tutorial days registered
                  </dt>
                  <dd className="text-sm font-medium">
                    {getTutorialDaysString(data)}
                  </dd>
                </div>
              ) : (
                <> </>
              )}
            </dl>
          </div>
        </div>

        <div>
          <h3 className="mb-2 text-sm font-medium text-gray-500">
            Social Events access
          </h3>
          <div className="rounded-lg border p-4">
            <dl className="space-y-4">
              <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">
                  Welcome Reception:
                </dt>
                <dd className="text-sm font-medium"> {data.receptions.length > 0 ? "Yes" : "No"}</dd>
              </div>

              {data.receptions.length > 1 && (
                <div className="flex justify-between">
                  <dt className="text-sm font-medium text-gray-500">
                    - Accompanying Person:
                  </dt>
                  <dd className="text-sm font-medium"> {`Yes (${data.receptions.length - 1})`}</dd>
                </div>
              )}


              <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">
                  Student Reception:
                </dt>
                <dd className="text-sm font-medium">
                  {data.student_receptions.length > 0 ? "Yes" : "No"}
                </dd>
              </div>

              {data.student_receptions.length > 1 && (
                <div className="flex justify-between">
                  <dt className="text-sm font-medium text-gray-500">
                    - Accompanying Person:
                  </dt>
                  <dd className="text-sm font-medium"> {`Yes (${data.student_receptions.length - 1})`}</dd>
                </div>
              )}

              <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">
                  Banquet:
                </dt>
                <dd className="text-sm font-medium">
                  {data.gala_dinners.length > 0 ? "Yes" : "No"}
                </dd>
              </div>

              {data.gala_dinners.length > 1 && (
                <div className="flex justify-between">
                  <dt className="text-sm font-medium text-gray-500">
                    - Accompanying Person:
                  </dt>
                  <dd className="text-sm font-medium"> {`Yes (${data.gala_dinners.length - 1})`}</dd>
                </div>
              )}

              <div className="flex justify-between">
                <dt className="text-sm font-medium text-gray-500">
                  Diversity &amp; Inclusion Lunch:
                </dt>
                <dd className="text-sm font-medium">
                  {data.cart?.diversity_inclusion > 0
                    ? data.cart.diversity_inclusion > 1
                      ? `Yes (${data.cart.diversity_inclusion})`
                      : "Yes"
                    : "No"}
                </dd>
              </div>

            </dl>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <h3 className="mb-2 text-sm font-medium text-gray-500">
          Additional Options
        </h3>
        <div className="rounded-lg border p-4">
          <ul className="space-y-2">
            <ItemCheck
              condition={true}
              text={"Invitation letter (administrative purposes)"}
            />
            <ItemCheck
              condition={data.invitation_letter}
              text={"Invitation letter for visa"}
            />
          </ul>
        </div>
      </div>
    </div>
  );
};
